import {  
  Award,  
  Bell,  
  BookMarked,  
  BookOpen,  
  BookOpenCheck,  
  BookUser,  
  Briefcase,  
  CheckCircle,  
  CheckCircle2,  
  ChevronDown,  
  ChevronLeft,  
  ChevronRight,  
  ClipboardIcon,  
  ClipboardList,  
  DollarSign,  
  FileBarChart,  
  FileCheck,  
  FilePlus,  
  FileQuestion,  
  FilesIcon,  
  FileSpreadsheet,  
  FileText,  
  History,  
  HomeIcon,  
  IdCard,  
  Inbox,  
  Layers,  
  LayoutDashboard,  
  List,  
  Lock,  
  LogOut,  
  MessageSquare,  
  PenTool,  
  Plus,  
  Settings,  
  UserCheck,  
  UserCircle,  
  UserCog,  
  UserMinus,  
  UserPlus,  
  Users  
} from 'lucide-react';  
import { useState } from 'react';  
import { NavLink } from 'react-router-dom';  
import { cn } from '../../lib/utils';  
import { Button } from '../ui/button';  
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '../ui/collapsible';  
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../ui/tooltip';  

//@ts-ignore  
import fullLogo from '../../assets/logo/ByteSplash_Logo.png';  
//@ts-ignore  
import logoOnly from '../../assets/logo/Logo_only.png';  

interface SidebarProps {  
  className?: string;  
  isLoggedIn?: boolean;  
}  

const Sidebar = ({ className, isLoggedIn = false }: SidebarProps) => {  
  const [collapsed, setCollapsed] = useState(false);  
  const [openSubMenu, setOpenSubMenu] = useState<string | null>(null);  
  const [activeSubMenuItem, setActiveSubMenuItem] = useState<string | null>(null);  

  const sidebarItems = [  
    { icon: LayoutDashboard, label: 'Dashboard', path: '/dashboard' },  
    {  
      icon: BookOpen,  
      label: 'Courses',  
      path: '/courses',  
      hasSubmenu: true,  
      submenuItems: [  
        { icon: List, label: 'All Courses', path: '/courses' },  
        { icon: Plus, label: 'Create Course', path: '/courses/create' },  
      ]  
    },  
    {  
      icon: Users,  
      label: 'Students',  
      path: '/students',  
      hasSubmenu: true,  
      submenuItems: [  
        { icon: List, label: 'All Students', path: '/students' },  
        {icon: List, label: 'External Students', path: '/students/external-list'},
        { icon: UserPlus, label: 'Register Student', path: '/students/register' },  
        { icon: FilePlus, label: 'Draft Registration', path: '/register-draft' },  
        { icon: FileSpreadsheet, label: 'Fee List', path: '/students/fee-list' },  
        { icon: ClipboardList, label: 'Check Students Data', path: '/students/check-data' },  
      ]  
    },  
    {  
      icon: Layers,  
      label: 'Batches',  
      path: '/batches',  
      hasSubmenu: true,  
      submenuItems: [  
        { icon: List, label: 'All Batches', path: '/batches' },  
        { icon: Plus, label: 'Create Batch', path: '/batches/create' },  
      ]  
    },  
    {  
      icon: BookMarked,  
      label: 'LMS',  
      path: '/lms',  
      hasSubmenu: true,  
      submenuItems: [  
        { icon: FileText, label: 'LMS Waiting List', path: '/lms/waiting-list' },  
        { icon: CheckCircle, label: 'Manage LMS Access', path: '/lms/manage-access' },  
        { icon: Plus, label: 'Provide New Access', path: '/lms/provide-access' },  
      ]  
    },  
    {  
      icon: Briefcase,  
      label: 'Employees',  
      path: '/employees',  
      hasSubmenu: true,  
      submenuItems: [  
        { icon: List, label: 'All Employees', path: '/employees' },  
        { icon: UserPlus, label: 'Onboarding', path: '/employees/onboarding' },  
        { icon: FileSpreadsheet, label: 'Payslips', path: '/employees/payslips' },  
        { icon: DollarSign, label: 'Salary Structures', path: '/employees/salary' },  
        { icon: UserMinus, label: 'Offboarding', path: '/employees/offboarding' }  
      ]  
    },  
    {  
      icon: UserCog,  
      label: 'Admin Actions',  
      path: '/admin',  
      hasSubmenu: true,  
      submenuItems: [  
        { icon: UserCog, label: 'Manage Users', path: '/admin/manage-access' },  
        { icon: UserPlus, label: 'Create New User', path: '/admin/create-user' },  
        { icon: BookMarked, label: 'Manage LMS Access', path: '/admin/lms-access' },  
        { icon: Lock, label: 'Reset Password', path: '/admin/reset-password' },  
        { icon: FileText, label: 'Auth Requests List', path: '/admin/auth-requests' },  
        { icon: IdCard, label: 'ID Card Waiting List', path: '/admin/id-card-waiting' },  
      ]  
    }, 
     {  
      icon: Award,  
      label: 'Certificates',  
      path: '/certificates',  
      hasSubmenu: true,  
      submenuItems: [  
        { icon: List, label: 'Student List', path: '/certificates' },  
        { icon: FileCheck, label: 'Generate Certificate', path: '/certificates/generate' },  
      ]  
    }, 
     { icon: FilesIcon, label: 'Files', path: '/file',
     hasSubmenu: true,
      submenuItems: [
        { icon: HomeIcon, label: 'Files Dashboard', path: '/file/filesdashboard' },
        { icon: FileText, label: 'All Files', path: '/file/files' },
      ]
     }, 
    {  
      icon: MessageSquare,  
      label: 'Enquiries',  
      path: '/enquiries',  
      hasSubmenu: true,  
      submenuItems: [  
        { icon: FileQuestion, label: 'Enquiry Requests', path: '/enquiries/requests' },  
        { icon: PenTool, label: 'Drive Requests', path: '/enquiries/drive' },  
        { icon: FileCheck, label: 'Offer Registrations', path: '/enquiries/offers' },  
        { icon: FileText, label: 'Syllabus Requests', path: '/enquiries/syllabus' },  
        { icon: MessageSquare, label: 'Contactus Requests', path: '/enquiries/contactus' },  
        { icon: CheckCircle2 , label :'Job Registrations', path:'/enquiries/careergapregistrations'}
      ]  
    },  
    {  
      icon: History,  
      label: 'Logs',  
      path: '/logs',  
      hasSubmenu: true,  
      submenuItems: [  
        { icon: BookUser, label: 'LMS Logins', path: '/logs/lms' },  
        { icon: UserCheck, label: 'Registration Logins', path: '/logs/registration' },  
        { icon: BookOpenCheck, label: 'Information Logins', path: '/logs/information' },  
        { icon: ClipboardIcon, label: 'Access Requests', path: '/logs/access' },  
        { icon: BookOpen, label: 'Course Registrations', path: '/logs/courses' },  
        { icon: FilePlus, label: 'Draft Submissions', path: '/logs/submissions' },  
        { icon: FileCheck, label: 'Draft Approvals', path: '/logs/approvals' },  
      ]  
    },  
    { icon: IdCard, label: 'ID Card', path: '/id-card' },  
    { icon: Users, label: 'Users', path: '/users' },    
    
    { icon: FileBarChart, label: 'Reports', path: '/reports' },  
    { icon: UserCircle, label: 'Profile', path: '/profile' },  
    { icon: Settings, label: 'Settings', path: '/settings' },  
    { icon: Bell, label: 'Notification', path: '/notification' },  
    { icon: Inbox, label: 'Inbox', path: '/chat' },  
  ];  

  const handleSubMenuClick = (subItemPath: string) => {  
    setActiveSubMenuItem(subItemPath);  
  };  

  const toggleSidebar = () => {  
    // When collapsing the sidebar, reset the open submenu  
    setCollapsed((prev) => {  
      // Collapse state changes, reset the open submenu  
      if (prev) {  
        setOpenSubMenu(null); // Collapse all submenus  
      }  
      return !prev; // Toggle the sidebar collapsed state  
    });  
    setActiveSubMenuItem(null);  
    setOpenSubMenu(null);  
  };  

  return (  
    <>  
      {isLoggedIn && (  
        <div  
          className={cn(  
            'h-auto bg-bytesplash-blue text-white flex flex-col transition-all duration-300 ease-in-out relative z-20',  
            collapsed ? 'w-[4.5rem]' : 'w-[15rem]',  
            className  
          )}  
        >  
          <div className={cn(  
            'flex bg-white items-center p-4 border-b border-white/10',  
            collapsed ? 'justify-center' : 'justify-start'  
          )}>  
            <div className="flex items-center bg-white">  
              {collapsed ? (  
                <NavLink to="" className="mr-1 flex items-center bg-white">  
                  <div className="w-8 h-8 grid place-items-center bg-white rounded">  
                    <img src={logoOnly} alt="Bytesplash Logo" width={60} height={60} className="animate-rotateSlow" />  
                  </div>  
                </NavLink>  
              ) : (  
                <NavLink to="" className="flex flex-col items-center">  
                  <img src={fullLogo} alt="Bytesplash Logo" className="w-36 h-auto" />  
                  <span className="text-gray-500 font-semibold text-md" style={{ fontFamily: 'Calibri, sans-serif' }}>Registration portal</span>  
                </NavLink>  
              )}  
            </div>  
          </div>  

          <div className="flex-1 flex flex-col mt-5 overflow-y-auto">  
            <TooltipProvider delayDuration={0}>  
              <ul className="space-y-1 px-3">  
                {sidebarItems.map((item, index) => (  
                  <li key={index}>  
                    {item.hasSubmenu ? (  
                      <div>  
                        <Collapsible  
                          onOpenChange={(open) => {  
                            if (!collapsed) {  
                              setOpenSubMenu(open ? item.label : null);  
                            }  
                          }}  
                          open={openSubMenu === item.label}  
                          className="space-y-1"  
                        >  
                          <CollapsibleTrigger className="w-full">  
                            <div  
                              className={cn(  
                                'flex items-center justify-between w-full rounded-md p-3 transition-colors',  
                                openSubMenu === item.label  
                                  ? 'bg-white text-bytesplash-blue'  
                                  : 'text-white'  
                              )}  
                            >  
                              <div className="flex items-center space-x-3">  
                                {collapsed ? (  
                                  <item.icon size={20} />  
                                ) : (  
                                  <>  
                                    <item.icon size={20} />  
                                    <span>{item.label}</span>  
                                  </>  
                                )}  
                              </div>  
                              <ChevronDown  
                                size={16}  
                                className={cn(  
                                  'transition-transform duration-200',  
                                  openSubMenu === item.label ? 'rotate-180' : ''  
                                )}  
                              />  
                            </div>  
                          </CollapsibleTrigger>  
                          <CollapsibleContent className="space-y-1 ml-8">  
                            {item.submenuItems?.map((subItem, subIndex) => (  
                              <NavLink  
                                key={subIndex}  
                                to={subItem.path}  
                                onClick={() => handleSubMenuClick(subItem.path)}  
                                className={({ isActive }) => cn(  
                                  'flex items-center space-x-3 rounded-md p-2 transition-colors',  
                                  (isActive && activeSubMenuItem === subItem.path) // Highlight only the active submenu  
                                    ? 'bg-white text-bytesplash-blue'  
                                    : 'hover:bg-bytesplash-blue/80 hover:text-white/90 text-white/70'  
                                )}  
                              >  
                                <subItem.icon size={16} />  
                                <span className="text-sm">{subItem.label}</span>  
                              </NavLink>  
                            ))}  
                          </CollapsibleContent>  
                        </Collapsible>  
                      </div>  
                    ) : (  
                      <NavLink  
                        to={item.path}  
                        onClick={() => {  
                          setOpenSubMenu(null);  
                          setActiveSubMenuItem(null); // Reset active submenu when main link is clicked  
                        }}  
                        className={({ isActive }) => cn(  
                          'flex items-center space-x-3 rounded-md p-3 transition-colors',  
                          isActive  
                            ? 'bg-white text-bytesplash-blue'  
                            : 'hover:bg-bytesplash-blue hover:text-white/90 text-white/70'  
                        )}  
                      >  
                        {collapsed ? (  
                          <item.icon size={20} />  
                        ) : (  
                          <>  
                            <item.icon size={20} />  
                            <span>{item.label}</span>  
                          </>  
                        )}  
                      </NavLink>  
                    )}  
                  </li>  
                ))}  
              </ul>  
            </TooltipProvider>  
          </div>  

          <div className={cn(  
            'p-4 border-t border-white/10 flex',  
            collapsed ? 'justify-center' : 'justify-start'  
          )}>  
            {collapsed ? (  
              <Tooltip>  
                <TooltipTrigger asChild>  
                  <Button variant="ghost" size="icon" className="text-white/70 hover:text-white/90 hover:bg-bytesplash-blue">  
                    <LogOut size={20} />  
                  </Button>  
                </TooltipTrigger>  
                <TooltipContent side="right">  
                  <p>Logout</p>  
                </TooltipContent>  
              </Tooltip>  
            ) : (  
              <Button variant="ghost" className="w-full text-white/70 hover:text-white/90 hover:bg-bytesplash-blue flex justify-start gap-3">  
                <LogOut size={20} />  
                <span>Logout</span>  
              </Button>  
            )}  
          </div>  

          <button  
            onClick={toggleSidebar}  
            className="absolute -right-3 top-20 bg-white text-bytesplash-blue rounded-full p-1 shadow-md hover:bg-gray-100 transition-colors"  
          >  
            {collapsed ? <ChevronRight size={16} /> : <ChevronLeft size={16} />}  
          </button>  
        </div>  
      )}  
    </>  
  );  
};  

export default Sidebar;  